import { DatePipe } from '@angular/common';
import { Component, inject, signal } from '@angular/core';
import { TableRowDirective } from '@core/primevue/directives/table-row.directive';
import { KeepScrollPositionDirective } from '@shared/directives/keep-scroll-position.directive';
import { DialogModule } from 'primeng/dialog';
import { TableLazyLoadEvent, TableModule } from 'primeng/table';
import { BatchJobDetailComponent } from '../batch-job-detail/batch-job-detail.component';
import { BatchJob } from './batch-job.model';
import { BatchService } from '../batch.service';

@Component({
  selector: 'app-batch-job',
  imports: [
    TableRowDirective,
    TableModule,
    DatePipe,
    KeepScrollPositionDirective,
    DialogModule,
    BatchJobDetailComponent,
  ],
  templateUrl: './batch-job.component.html',
  styleUrl: './batch-job.component.css',
})
export class BatchJobComponent {
  batchService = inject(BatchService);
  jobData = this.batchService.batchJobDatasource.data;
  showDetails = signal(false);

  onRowSelect() {
    this.showDetails.set(true);
  }

  onLazyLoad(event: TableLazyLoadEvent) {
    this.batchService.batchJobDatasource.loadData(
      event.sortField,
      event.sortOrder === -1,
      event.first
    );
  }

  rowClass(item: BatchJob) {
    let cls = '';
    if (item.status === 'Failed') {
      cls += '!text-lpred ';
    }
    return cls;
  }

  onHideJobDetails() {
    this.batchService.selectedBatchJob.set(undefined);
  }
}
